// define Namespace
var fzw = fzw || {};

// External links open in a new tab/window
// (rel="noopener" not needed as implicitly set by all modern browsers)
fzw.externalLinks = {
    init: function () {
        var links = document.links;
        for (var i = 0; i < links.length; i++) {
            if (links[i].hostname != window.location.hostname && !links[i].classList.contains("js-lightbox") && !links[i].classList.contains("tel") && !links[i].id.endsWith("exit")) { // lightbox and exit buttons must be in the same window
                links[i].setAttribute("rel", "external"); // optional
                links[i].target = "_blank";
            }
        }
    }
};

// Initiate namespaced functions
fzw.externalLinks.init();   // External links




// Image scrollers
const scrollers = document.querySelectorAll('.splide.splide--scroller');
if (scrollers.length) {

    const scrollerSpeed = 625; // milliseconds

    (async () => {
        // dynamic module import
        const { Splide } = await import('./vendors/splide.esm.js');
        const { Intersection } = await import('./vendors/splide-extension-intersection.esm.js');

        // Loop over instances
        for (const scroller of scrollers) {
            const splide = new Splide(scroller, {
                type        : 'loop',
                drag        : 'free',
                focus       : 'center',
                autoWidth   : true,
                arrows      : false,
                pagination  : false,
                autoplay    : 'pause',
                speed       : scrollerSpeed,

                intersection: {
                    inView: {
                        autoplay: true
                    },
                    outView: {
                        autoplay: false
                    }
                },
                reducedMotion: {
                    autoplay: false
                }
            }).mount(
                { Intersection }
            );
        }

    })();
}



// Image slider
const sliders = document.querySelectorAll('.js-slider');
if (sliders.length) {

    (async () => {
        // dynamic module import
        const { Splide } = await import('./vendors/splide.esm.js');

        // loop over all instances
        for (const slider of sliders) {
            const splide = new Splide(slider, {
                type        : 'loop',
                drag        : true,
                arrowPath   : 'M26.95,18.33l-8.94-8.94,2.36-2.36,12.96,12.96-12.96,12.96-2.36-2.36,8.94-8.94H6.67v-3.33h20.29Z', // remixicon arrow-right
            });

            splide.on('pagination:mounted', function (data) {
                // data.items contains all dot items
                data.items.forEach(function (item) {
                    // add the page number (1-based index) to button textContent
                    item.button.textContent = String(item.page + 1);

                    // add class for styling
                    item.button.classList.add('splide__pagination__page--number');
                });
            });

            // initiate splide
            splide.mount();
        }
    })();
}



// Gallery : horizontal tiled layouts
// Using: https://github.com/MichiruKagemori/flow-gallery/
// (Mirror of henningrck/flow-gallery)
const tileGalleries = document.querySelectorAll('.js-tile-gallery');
if (tileGalleries.length) {

    (async () => {
    // dynamic module import
    const { default: FLowGallery } = await import('./vendors/flow-gallery.min.js');

        const tileGalleryInstance = [];
        let i = 1;

        for (const tileGallery of tileGalleries) {
            // Give each gallery a unique id so it can have its own settings
            // tileGallery.setAttribute('id','tile-gallery' + i);
            // +++ html id IS SET IN TXP SHORTCODE not here +++

            tileGalleryInstance[i] = new FlowGallery({
                selector: '#tile-gallery' + i,
                maxHeight: parseInt(tileGallery.dataset.rowheight),
                gapWidth: parseInt(tileGallery.dataset.gap),
                fillLastLine: true
            });
            i++;
        }

    })();
}



// Parvus German language strings
var de = {
    lightboxLabel: 'Dies ist ein Dialogfenster, das den Hauptinhalt der Seite überlagert. Das Modal zeigt das vergrößerte Bild an. Durch Drücken der Escape-Taste wird das Modal geschlossen und Sie gelangen zurück zu Ihrem vorherigen Standpunkt auf der Seite.',
    lightboxLoadingIndicatorLabel: 'Bild wird geladen',
    lightboxLoadingError: 'Das angeforderte Bild kann nicht geladen werden.',
    controlsLabel: 'Steuerungen',
    previousButtonLabel: 'Vorheriges Bild',
    nextButtonLabel: 'Nächstes Bild',
    closeButtonLabel: 'Dialogfenster schließen',
    sliderLabel: 'Bilder',
    slideLabel: 'Bild'
};

const lightboxes = document.querySelectorAll('.js-lightbox');

if (lightboxes.length) {

    (async () => {
    // dynamic module import
    const { default: Parvus } = await import('./vendors/parvus.esm.min.js');

        const prvs = new Parvus({
            selector: '.js-lightbox',
            captions: true,
            l10n: de,
            lightboxIndicatorIcon: '<svg class="icon lightbox-show"><use href="/themes/fzw/assets/icons/site-icons.svg#add-circle"></use></svg>',
            previousButtonIcon: '<svg class="icon lightbox-arrows lightbox-prev"><use href="/themes/fzw/assets/icons/site-icons.svg#arrow-left"></use></svg>',
            nextButtonIcon: '<svg class="icon lightbox-arrows lightbox-next"><use href="/themes/fzw/assets/icons/site-icons.svg#arrow-right"></use></svg>',
            closeButtonIcon: '<svg class="icon lightbox-close"><use href="/themes/fzw/assets/icons/site-icons.svg#close-circle"></use></svg>'
        })

    })();
}




// Error notices
const errorNotice = document.querySelector('body > pre:first-child');
const errorBacktrace = document.querySelector('pre.backtrace');

// If neither exists, do nothing
if (errorNotice && errorBacktrace) {
    // Create the errorWrapper div
    const errorWrapper = document.createElement('div');
    errorWrapper.className = 'error-wrapper';

    // Insert the wrapper before the first of the elements to be wrapped
    let insertBeforeElem = errorNotice || errorBacktrace;
    insertBeforeElem.parentNode.insertBefore(errorWrapper, insertBeforeElem);

    errorWrapper.appendChild(errorNotice);
    errorWrapper.appendChild(errorBacktrace);

    // Assume your wrapper element has an ID, e.g., 'wrapper'
    const wrapper = document.getElementById('wrapper');

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            // Toggle the display property
            if (errorWrapper.style.display === 'none' || getComputedStyle(errorWrapper).display === 'none') {
                errorWrapper.style.display = 'block';
            } else {
                errorWrapper.style.display = 'none';
            }
        }
    });
};



const memberForm = document.querySelector('.form.mitglied-werden');

if (memberForm) {
    const amountRadios = document.querySelectorAll('input[name="amountGroup"]');
    const otherAmountInput = document.getElementById('otherAmount');
    const otherWrapper = document.getElementById('otherWrapper');
    const amountError = document.getElementById('amountError');
    const finalAmountInput = document.getElementById('finalAmount');

    const paymentRadios = document.querySelectorAll('input[name="paymentMethod"]');
    const bankTransferFields = document.getElementById('bankTransferFields');
    const bankDeductionFields = document.getElementById('bankDeductionFields');
    const kontoinhaberInput = document.getElementById('kontoinhaber');
    const ibanInput = document.getElementById('iban');
    const bicInput = document.getElementById('bic');
    const frequencyRadios = document.querySelectorAll('input[name="zahlungsinterval"]');

    const dobDayInput = document.getElementById('dobDay');
    const dobMonthInput = document.getElementById('dobMonth');
    const dobYearInput = document.getElementById('dobYear');
    const dobDayError = document.getElementById('dobDayError');
    const dobMonthError = document.getElementById('dobMonthError');
    const dobYearError = document.getElementById('dobYearError');
    const dobError = document.getElementById('dobError');
    const finalDateOfBirth = document.getElementById('finalDateOfBirth');

    // Configuration
    const MIN_YEAR = 1930;
    const MAX_YEAR = new Date().getFullYear() - 13; // Must be at least 13 years old
    const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // ==== Amount Selection ====
    amountRadios.forEach(radio => {
        radio.addEventListener('change', function() {
            if (this.value === 'other') {
                otherWrapper.classList.add('active');
                otherAmountInput.focus();
            } else {
                otherWrapper.classList.remove('active');
                amountError.textContent = '';
            }
            updateFinalAmount();
        });
    });

    otherAmountInput.addEventListener('input', updateFinalAmount);

    function updateFinalAmount() {
        amountError.textContent = '';
        const selectedRadio = document.querySelector('input[name="amountGroup"]:checked');

        if (!selectedRadio) {
            finalAmountInput.value = '';
            return;
        }

        if (selectedRadio.value === 'other') {
            const otherValue = otherAmountInput.value.trim();
            if (otherValue === '') {
                finalAmountInput.value = '';
            } else {
                const parsedValue = parseFloat(otherValue);
                if (isNaN(parsedValue) || parsedValue <= 5) {
                    amountError.textContent = 'Bitte geben Sie einen Betrag über 5 € ein';
                    finalAmountInput.value = '';
                } else {
                    finalAmountInput.value = parsedValue;
                }
            }
        } else {
            finalAmountInput.value = selectedRadio.value;
        }
    }

    // ==== Payment Method =====
    paymentRadios.forEach(radio => {
        radio.addEventListener('change', function() {
            if (this.value === 'bank_ueberweisung') {
                bankTransferFields.classList.add('active');
                setConditionalFieldsRequired(false);
            } else {
                bankTransferFields.classList.remove('active');
                setConditionalFieldsRequired(false);
            }

            if (this.value === 'bank_lastschrift') {
                bankDeductionFields.classList.add('active');
                setConditionalFieldsRequired(true);
            } else {
                bankDeductionFields.classList.remove('active');
                setConditionalFieldsRequired(false);
            }
        });
    });

    function setConditionalFieldsRequired(isRequired) {
        kontoinhaberInput.required = isRequired;
        ibanInput.required = isRequired;
        bicInput.required = isRequired;
        frequencyRadios.forEach(radio => {
            radio.required = isRequired;
        });
    }

    // ==== Date of Birth ====
    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    }

    function getDaysInMonth(month, year) {
        if (month === 2 && isLeapYear(year)) {
            return 29;
        }
        return DAYS_IN_MONTH[month - 1];
    }

    function validateDateInput(day, month, year) {
        day = parseInt(day, 10);
        month = parseInt(month, 10);
        year = parseInt(year, 10);

        const errors = {};

        // Validate day
        if (isNaN(day) || day < 1 || day > 31) {
            errors.day = 'Der Tag muss zwischen dem 1. und dem 31. liegen';
        }

        // Validate month
        if (isNaN(month) || month < 1 || month > 12) {
            errors.month = 'Der Monat muss zwischen 1 und 12 liegen';
        }

        // Validate year
        if (isNaN(year) || year < MIN_YEAR || year > MAX_YEAR) {
            errors.year = `Das Jahr muss zwischen ${MIN_YEAR} und ${MAX_YEAR} liegen`;
        }

        // If day and month are valid, check if day is valid for that month
        if (!errors.day && !errors.month && !errors.year) {
            const maxDaysInMonth = getDaysInMonth(month, year);
            if (day > maxDaysInMonth) {
                errors.day = `Der Tag muss für diesen Monat zwischen 1 und ${maxDaysInMonth} liegen`;
            }
        }

        return errors;
    }

    function updateDateOfBirth() {
        dobDayError.textContent = '';
        dobMonthError.textContent = '';
        dobYearError.textContent = '';
        dobError.textContent = '';

        const day = dobDayInput.value.trim();
        const month = dobMonthInput.value.trim();
        const year = dobYearInput.value.trim();

        // If all fields are filled
        if (day && month && year) {
            const errors = validateDateInput(day, month, year);

            if (errors.day) dobDayError.textContent = errors.day;
            if (errors.month) dobMonthError.textContent = errors.month;
            if (errors.year) dobYearError.textContent = errors.year;

            if (Object.keys(errors).length === 0) {
                // Format and set the hidden input
                const formattedDay = String(parseInt(day, 10)).padStart(2, '0');
                const formattedMonth = String(parseInt(month, 10)).padStart(2, '0');
                const formattedYear = String(parseInt(year, 10)).padStart(4, '0');
                finalDateOfBirth.value = `${formattedDay}.${formattedMonth}.${formattedYear}`;
            } else {
                finalDateOfBirth.value = '';
            }
        } else {
            finalDateOfBirth.value = '';
        }
    }

    // Auto-format and validate as user types
    dobDayInput.addEventListener('input', function() {
        if (this.value.length === 2 && /^\d+$/.test(this.value)) {
            const day = parseInt(this.value, 10);
            if (day > 31) {
                this.value = '';
            }
        }
        updateDateOfBirth();
    });

    dobMonthInput.addEventListener('input', function() {
        if (this.value.length === 2 && /^\d+$/.test(this.value)) {
            const month = parseInt(this.value, 10);
            if (month > 12) {
                this.value = '';
            } else if (month > 0) {
                dobDayInput.focus();
            }
        }
        updateDateOfBirth();
    });

    dobYearInput.addEventListener('input', function() {
        if (this.value.length === 4 && /^\d+$/.test(this.value)) {
            updateDateOfBirth();
        } else if (this.value.length > 4) {
            this.value = this.value.slice(0, 4);
        }
    });

    // Only allow numeric input
    [dobDayInput, dobMonthInput, dobYearInput].forEach(input => {
        input.addEventListener('keypress', function(e) {
            if (!/\d/.test(e.key)) {
                e.preventDefault();
            }
        });
    });

    // ==== Submit form ====
    memberForm.addEventListener('submit', function(e) {
        e.preventDefault();

        // Validate amount
        const selectedAmount = document.querySelector('input[name="amountGroup"]:checked');
        if (!selectedAmount) {
            // alert('Bitte wählen Sie einen Betrag aus');
            beitragError.textContent = 'Bitte wählen Sie einen Betrag aus';
            return;
        }

        if (selectedAmount.value === 'other') {
            const otherValue = otherAmountInput.value.trim();
            if (otherValue === '' || isNaN(parseFloat(otherValue)) || parseFloat(otherValue) <= 0) {
                amountError.textContent = 'Bitte geben Sie einen Betrag über 5 € ein';
                return;
            }
        }

        // Validate payment method
        const selectedPayment = document.querySelector('input[name="paymentMethod"]:checked');
        if (!selectedPayment) {
            //alert('Please select a payment method');
            zahlungsweiseError.textContent = 'Bitte wählen Sie eine Zahlungsweise aus';
            return;
        }

        if (selectedPayment.value === 'bank_lastschrift') {
            if (!kontoinhaberInput.value.trim()) {
                // alert('Bitte geben Sie den Kontoinhaber ein');
                kontoinhaberError.textContent = 'Bitte geben Sie den Kontoinhaber ein';
                kontoinhaberInput.focus();
                return;
            }
            if (!ibanInput.value.trim()) {
                // alert('Bitte geben Sie Ihre IBAN ein');
                ibanError.textContent = 'Bitte geben Sie Ihre IBAN ein';
                ibanInput.focus();
                return;
            }
            if (!bicInput.value.trim()) {
                // alert('Bitte geben Sie Ihre BIC ein');
                bicError.textContent = 'Bitte geben Sie Ihre BIC ein';
                bicInput.focus();
                return;
            }
            /*
            const selectedFrequency = document.querySelector('input[name="zahlungsinterval"]:checked');
            if (!selectedFrequency) {
                alert('Bitte wählen Sie eine Zahlungshäufigkeit aus');
                return;
            }
            */
        }

        // Validate date of birth
        const day = dobDayInput.value.trim();
        const month = dobMonthInput.value.trim();
        const year = dobYearInput.value.trim();

        if (!day || !month || !year) {
            dobError.textContent = 'Bitte geben Sie ein vollständiges Geburtsdatum ein';
            return;
        }

        const dateErrors = validateDateInput(day, month, year);
        if (Object.keys(dateErrors).length > 0) {
            if (dateErrors.day) dobDayError.textContent = dateErrors.day;
            if (dateErrors.month) dobMonthError.textContent = dateErrors.month;
            if (dateErrors.year) dobYearError.textContent = dateErrors.year;
            return;
        }

        // If all validations pass, log the data and submit
        console.log('Form data:', {
            Betrag: finalAmountInput.value,
            Zahlungsweise: selectedPayment.value,
            Kontoinhaber: kontoinhaberInput.value || undefined,
            IBAN: ibanInput.value || undefined,
            BIC: bicInput.value || undefined,
            zahlungsinterval: document.querySelector('input[name="zahlungsinterval"]:checked')?.value || undefined,
            Geburtsdatum: finalDateOfBirth.value
        });

        // Uncomment to actually submit:
        // this.submit();
    });

}


const form = document.querySelector("form");

if (form) {
    function validateField(field) {
    const errorEl =
        field.type === "radio"
        ? field.closest("fieldset").querySelector(".error-message")
        : field.parentElement.querySelector(".error-message");

    if (!field.validity.valid) {
        errorEl.textContent = document.querySelector("label[for='"+field.id+"']").dataset.error || "Dieses Feld bitte ausfüllen";
        return false;
    }

    errorEl.textContent = "";
    return true;
    }

    form.querySelectorAll("input, textarea").forEach((input) => {
    input.addEventListener("blur", () => {
        validateField(input);
    });
    });

    form.addEventListener("submit", function (e) {
    e.preventDefault();

    let isValid = true;

    const fields = form.querySelectorAll("input, textarea");

    fields.forEach((field) => {
        console.log(`Checking ${field.name}`);
        const fieldValid = validateField(field);

        if (!fieldValid) {
        isValid = false;
        }
    });

    if (isValid) {
        // send form data
        form.reset();
    } else {
        form.querySelector(":invalid").focus();
    }
    });
}


// Back to top button
(function () {
    // Reveal toTopButton on scroll; never show on short pages
    const toTopButton = document.querySelector('.js-scroll-to-top');
    const revealOffset = 500; // scroll distance in px before button shows
    let scrolling = false;

    // window.scroll callback function - reveal if window is scrolled further than revealOffset
    function checkBackToTop() {
        let windowTop = window.scrollY || document.documentElement.scrollTop;
        (windowTop > revealOffset) ? toTopButton.classList.add('is-visible') : toTopButton.classList.remove('is-visible');
        scrolling = false;
    }


    // window.scroll event listener
    if(toTopButton) {
        toTopButton.addEventListener('click', function(e) {
          e.preventDefault();

          // Smooth scroll to top
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });

        window.addEventListener("scroll", function() {
            if (!scrolling) {
                scrolling = true;
                (!window.requestAnimationFrame) ? setTimeout(checkBackToTop, 250) : window.requestAnimationFrame(checkBackToTop);
            }
        });
    }
})();
